<p-toast position="top-left"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-md-8">
        <lib-page-header page-title="Créditos Adicionais"
          page-subtitle="EXERCÍCIO:  {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
          image-title="assets/img/money4.png">
        </lib-page-header>
      </div>
      <div class="col-md-4">
        <a (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right  ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </a>
        <lib-export-list (acao)="exportarListagem($event)"></lib-export-list>
        <a *ngIf="podeIncluir()" [routerLink]="['/creditos/novo']" class="btn btn-sm btn-outline-success float-right">
          <img src="assets/img/global/plus.png" alt="novo" class="mr-2" title="Incluir" height="20" width="20">Novo
        </a>
      </div>
    </div>
    <hr class="mt-1 mb-4" />
    <div class="row">
      <div class="col-md-5">
        <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
        </lib-filtro>
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <div class="table-responsive">
          <table class="table table-eddy">
            <thead>
              <tr>
                <th scope="col">Decreto</th>
                <th scope="col">Lei</th>
                <th scope="col">Data</th>
                <th scope="col">Ocorrência</th>
                <th scope="col">Tipo de crédito</th>
                <th scope="col" style="width: 100px;"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of lista">
                <th scope="row">{{item.decreto}}</th>
                <th scope="row">{{item.lei}}</th>
                <td>{{item.data_credito | date:'dd/MM/yyyy':'GMT'}}</td>
                <td>
                  {{globalService.obterOcorrenciasCreditos(item.ocorrencia)}}
                </td>
                <td><span class="badge"
                    [ngClass]="item.tipo === '1' ? 'badge-success' : item.tipo === '3' ? 'badge-danger' : 'badge-warning'">
                    {{globalService.obterTiposCreditos(item.tipo)}} </span></td>
                <td class="text-right" style="min-width: 120px">
                  <button [routerLink]="['/creditos', item.id, 'visualizar']" routerLinkActive="router-link-active"
                    *ngIf="podeIncluir() && podeAlterar(item.data_credito)"
                    class="btn btn-sm btn-outline-secondary mr-2">
                    <img src="assets/img/global/zoom.png" alt="visualizar" height="16" width="16">
                  </button>
                  <button [routerLink]="['/creditos', item.id, 'editar']" routerLinkActive="router-link-active"
                    *ngIf="podeIncluir() && podeAlterar(item.data_credito)" class="btn btn-sm btn-outline-primary mr-2">
                    <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row float-right" *ngIf="lista && lista.length > 0">
      <div class="col-12 mb-5">
        <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
          (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
      </div>
    </div>
    <br>
    <br>
  </div>
</div>